import type { HTMLAttributes, ReactNode } from "react";

type MessageProps = HTMLAttributes<HTMLDivElement> & {
  role: "assistant" | "user";
  children: ReactNode;
};

export function Message({ role, children, className = "", ...props }: MessageProps) {
  return (
    <div className={`pk-message pk-message--${role} ${className}`} {...props}>
      {children}
    </div>
  );
}

export function MessageAvatar({ children }: { children: ReactNode }) {
  return <div className="pk-message-avatar" aria-hidden>{children}</div>;
}

export function MessageContent({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`pk-message-content ${className}`}>{children}</div>;
}

export function MessageActions({ children }: { children: ReactNode }) {
  return <div className="pk-message-actions">{children}</div>;
}

export function MessageAction({ children, label }: { children: ReactNode; label: string }) {
  return (
    <button type="button" aria-label={label} title={label} className="pk-message-action">
      {children}
    </button>
  );
}
